<!-- Orbi entry point (PCSA-13157). Design: initial-chat-input "Agent CTA" /
     "Input" — an Orbi-mark-prefixed "Ask a question" bar. Reuses the PCSA-13160
     message input so idle / typing / listening states stay in one component.
     Self-gated on the Orbi flag and hidden while the panel is open. On send it
     opens the panel and submits the message.

     Static-prompts MVP: the entry bar also hosts the "Make Sense of Your
     Results" popover, anchored to this fixed bar so it can point a caret at it
     and flip the caret per breakpoint. The bulb (prompt-toggle) inside the input
     re-opens the popover after dismiss. Both are gated to the results-detail
     route via the component's `shouldShowStaticPrompts` eligibility seam. -->
<div class="orbi-entry" *ngIf="(enabled$ | async) && (pageSettled$ | async) && (panelOpen$ | async) === false">
  <!-- Mobile/docked: the card sits IN the bar's box, above the field, so the
       bottom-anchored host grows upward and the card cannot be clipped. -->
  <div
    class="orbi-entry__static-prompts orbi-entry__static-prompts--above"
    *ngIf="staticPromptVisible && staticPromptCaretDirection === 'down'"
  >
    <patient-ui-static-prompt-card caretDirection="down" (dismiss)="onStaticPromptDismiss()"></patient-ui-static-prompt-card>
  </div>

  <patient-ui-orbi-message-input
    leadingIconSrc="assets/images/orbi-ai-icon.svg"
    placeholder="Ask a Question"
    [singleLine]="true"
    [showHistory]="true"
    [showPromptToggle]="showPromptToggle"
    [promptToggleActive]="staticPromptVisible"
    (send)="onAsk($event)"
    (history)="onHistory()"
    (promptToggle)="onStaticPromptToggle()"
    (activate)="onActivate()"
  ></patient-ui-orbi-message-input>

  <!-- Web: the card sits IN the bar's box, under the field, so the top-anchored
       host grows downward. Same width as the field, caret aimed at the bulb. -->
  <div
    class="orbi-entry__static-prompts orbi-entry__static-prompts--below"
    *ngIf="staticPromptVisible && staticPromptCaretDirection === 'up'"
  >
    <patient-ui-static-prompt-card caretDirection="up" (dismiss)="onStaticPromptDismiss()"></patient-ui-static-prompt-card>
  </div>
</div>
